import * as process from "process";

export const IS_CLOUD_BUILD = process.env.VUE_APP_PLATFORM === "cloud";
